import countries from 'i18n-iso-countries'
import type {CountryCode} from 'libphonenumber-js'

import {useLocale} from '@/providers/locale'

export const useCountryList = () => {
    const {language} = useLocale()

    countries.registerLocale(require(`i18n-iso-countries/langs/${language}.json`))

    const i18nCountryNames = countries.getNames(language)

    return (
        Object.entries(i18nCountryNames)
            // These countries are not supported by `libphonenumber-js`
            .filter(([code]) => !['AQ', 'BV', 'TF', 'HM', 'PN', 'GS', 'UM'].includes(code))
            .map(([code, name]) => ({
                code: code as CountryCode,
                name,
            }))
    )
}

export default useCountryList
